<template>
  <v-form v-bind="this.$attrs">
    <div class="wrap_filter">
      <v-row class="mb-0">
        <v-col cols="12">
          <GradeClassStudentSelect
            @changed="gradeClassStudentChange"
            :disableGradeSelect="user.role.type === 'teacher'"
            :autoSyncClassByStudent="false"
            :autoSyncGradeByClass="false"
          />
        </v-col>
      </v-row>
      <v-row class="d-flex justify-end mt-6">
        <div class="mr-3 d-flex justify-end align-end">
          <v-btn :disabled="loading" class="search-button" height="40" outlined @click="onFilter"> Tìm kiếm </v-btn>
        </div>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import DateISOPickerMargin from '@/components/basic/picker/DateISOPickerMargin.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
// TODO: filter with teacher
export default {
  components: {
    DateISOPickerMargin,
    GradeClassStudentSelect,
  },
  data() {
    return {
      from: null,
      to: null,
      classData: null,
      grade: null,
      student: null,
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      loading: 'studentDebt/loading',
    }),
  },
  created() {
    this.onFilter()
  },
  methods: {
    ...mapActions({
      fetchStudentDebt: 'studentDebt/fetchStudentDebt',
      countStudentDebt: 'studentDebt/countStudentDebt',
      getStats: 'studentDebt/getStats',
    }),
    ...mapMutations({
      setLoading: 'studentDebt/setLoading',
      setQuery: 'studentDebt/setQuery',
    }),
    gradeClassStudentChange(data) {
      this.grade = data.grade
      this.classData = data.class
      this.student = data.student
    },
    async onFilter() {
      try {
        this.setLoading(true)
        const query = {}
        if (this.classData) query.class = this.classData.id
        if (this.grade) query.grade = this.grade.id
        if (this.student) query.student = this.student.id
        await this.fetchStudentDebt({ ...query, _start: 0, _limit: 5 })
        await this.countStudentDebt(query)
        await this.getStats(query)
        this.setQuery(query)
      } catch (error) {
      } finally {
        this.setLoading(false)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 960px) {
  .wrap_filter {
    display: block;
  }
}
</style>
